import { render, staticRenderFns } from "./AddDeliverySuccess.vue?vue&type=template&id=4fad344e&"
import script from "./AddDeliverySuccess.vue?vue&type=script&lang=ts&"
export * from "./AddDeliverySuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AddDeliverySuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports